import React from 'react';
import { Col, Modal, Form, Input, TimePicker, Button, Row,message } from "antd";
import moment from 'moment';
import { Event } from 'react-big-calendar';
import { AddEvent } from "../../utils/API";
import { toast } from 'react-toastify';

interface Props {
  visible: boolean;
  loading: boolean;
  form: any;
  onOk: () => void;
  onCancel: () => void;
  onEventAdded?: () => void
  selectedSlot?: any
}

interface MyEvent {
  title: string;
  start: Date;
  end: Date;
  description?: string;
}

const AddCreateeventmodal: React.FC<Props> = ({ visible, loading, form, onOk, onCancel, onEventAdded, selectedSlot }) => {


  // In AddCreateeventmodal.tsx
  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      // Use the selected date from the form
      const selectedDate = moment(values.selectedDate || new Date());

      const start = selectedDate.clone()
        .hour(values.start.hour())
        .minute(values.start.minute())
        .second(0)
        .toDate();

      const end = selectedDate.clone()
        .hour(values.end.hour())
        .minute(values.end.minute())
        .second(0)
        .toDate();

      const payload = {
        title: values.title,
        description: values.description || '',
        start: start.toISOString(),
        end: end.toISOString()
      };

      try {
        await AddEvent(payload);
        message.success("Event added successfully");
        form.resetFields();
        onEventAdded?.();
        onCancel();
      } catch (error) {
        const err = error as any;
        const message = err?.response?.data?.error || err?.message || "Something went wrong";
        message.error(message);
        console.error("Form validation or submission failed:", message);
      }
    } catch (error) {
      if (error instanceof Error) {
        message.error(error.message);
      } else {
        message.error("An unexpected error occurred");
      }
    }
  };

  // Then use handleOk instead of onOk in your button
  return (
    <Modal
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={null}
      width={500}
      centered={false}
      destroyOnClose
      className="custom-modal"
      style={{
        bottom: 20,
        top: 20,
        maxHeight: 'calc(100vh - 30px)',
        margin: '0 auto',
        position: 'relative',
      }}
      title={
        <div style={{
          marginLeft: "11px",
          width: '100%',
          paddingRight: 20,
        }}>
          Create New Event
        </div>
      }
      bodyStyle={{
        overflowY: 'auto',
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          borderBottom: "1px solid #e0e0e0",
          padding: "12px",
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
        },
        content: {
          padding: 10,
          overflow: 'hidden'
        }
      }}
    >
      <Form form={form} layout="vertical">
        <div className="elements">
          {/* // Add this to your form items */}
          <Form.Item
            name="selectedDate"
            hidden // We'll keep it hidden since we get it from the calendar
          >
            <Input />

          </Form.Item>
          <Form.Item
            name="title"
            required={false}
            label={<span className="Inputlabel">Event Title <span className="text-danger">*</span></span>}
            rules={[{ required: true, message: 'Please input the event title!' }]}
          >
            <Input placeholder="Enter event title" className="Allinput" />
          </Form.Item>
          <Form.Item
            name="description"
            required={false}
            label={<span className="Inputlabel">Description</span>}
          >
            <Input.TextArea placeholder="Enter event description" className='Allinputtextarea' />
          </Form.Item>

          {/*  Start */}
          <Col xs={24}>
            <Form.Item
              name="start"
              required={false}
              rules={[{ required: true, message: "Please enter  Start Time" }]}
              label={
                <span className="Inputlabel">
                  Start Time <span className="text-danger">*</span>
                </span>
              }
            >
              <TimePicker use12Hours format="hh:mm A" className="Allinput" />
            </Form.Item>
          </Col>

          {/* Lunch Start */}
          <Col xs={24}>
            <Form.Item
              name="end"
              required={false}
              rules={[{ required: true, message: "Please enter  End  Time" }]}
              label={
                <span className="Inputlabel">
                  End Time<span className="text-danger">*</span>
                </span>
              }
            >
              <TimePicker use12Hours format="hh:mm A" className="Allinput" />
            </Form.Item>
          </Col>

        </div>
        <div className="footer-modals" />
        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onCancel}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="allsubmitebutton"
                onClick={handleOk}
                disabled={loading}
              >
                {loading ? "Add Event..." : "Add Event"}
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddCreateeventmodal;